export interface Filter {
  type: FilterType;
  name: string;
  active: boolean;
}

export enum FilterType {
  Day = 'day',
  Month = 'month',
  Year = 'year',
  Total = 'total',
}
